// SortingDropdownSlice.js
import { createSlice } from "@reduxjs/toolkit";

export const SortingDropdownReducer = createSlice({
  name: "sortingDropdown",
  initialState: {
      isOpen: false,
      currentSortOption: '인기순',
    //   sortingOptions: ['인기순', '신제품순', '가격 낮은 순', '가격 높은 순', '리뷰 많은 순']
    sortingOptions: ['인기순', '신제품순', '가격 낮은 순', '가격 높은 순']

  },
  reducers: {
      toggleDropdown: (state) => {
          state.isOpen = !state.isOpen;
      },
      closeDropdown: (state) => {
          state.isOpen = false;
      },
      setCurrentSortOption: (state, action) => {
          state.currentSortOption = action.payload;
      },
      resetSortingState: (state) => {
          state.currentSortOption = '인기순';
        //   state.sortingOptions = ['인기순', '신제품순', '가격 낮은 순', '가격 높은 순', '리뷰 많은 순'];
          state.sortingOptions = ['인기순', '신제품순', '가격 낮은 순', '가격 높은 순'];

      },
  },
});

export const { toggleDropdown, closeDropdown, resetSortingState , setCurrentSortOption } = SortingDropdownReducer.actions;
export default SortingDropdownReducer.reducer;
